import { render, staticRenderFns } from "./PointEditor.vue?vue&type=template&id=800c914e&scoped=true&"
import script from "./PointEditor.vue?vue&type=script&lang=ts&"
export * from "./PointEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PointEditor.vue?vue&type=style&index=0&id=800c914e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800c914e",
  null
  
)

export default component.exports